/* eslint max-len: "off" */
export default {
  detailText: {
    totalText: {
      'Productivity Perks':
        'NerdWallet offers perks and benefits that allow you to work smart, be healthy, and have fun!',
      'Health Benefits':
        'NerdWallet offers comprehensive and competitive benefits, because we take the health of our Nerds and their families to heart. You can choose from several different options to make sure you have what works best for your situation.',
      Salary:
        'Salary is a big consideration when making your decision. We provide Nerds with competitive salaries and a great environment where they can do their best work.',
      '401(k) Match':
        'Assuming you contribute at least 4% of your salary to your 401(k), NerdWallet will match dollar-for-dollar up to 4% of eligible compensation each year.',
    },
    perkText: {
      'Cell Phone':
        'Since communication is such an important tool, we pay a monthly $80 phone stipend to all Nerds who sign up and share their number with the company.',
      'Commuter Stipend':
        'A monthly transit stipend of $255 will help you get to the office as conveniently and cheaply as possible.',
      'Enrichment Stipend':
        'In the spirit of relentless self improvement, NerdWallet gives each Nerd an enrichment stipend of up to $500 per year for continuing professional development outside the office.',
      Food: 'Healthy, fresh and delicious breakfast and lunch, every day. Plus, plenty of great snacks.',
      Gym: 'A monthly $50 wellness subsidy that you can put towards the fitness center of your choice.',
    },
    healthText: {
      'Health Insurance':
        'NerdWallet offers two PPO options through Anthem or coverage through Kaiser so you can find the doctor that’s right for you.',
      'Dental Insurance':
        'Stay on top of your oral health with our dental insurance through Guardian.',
      'Vision Insurance':
        'NerdWallet uses VSP for vision insurance, which covers your yearly eye exam.',
    },
  },
  perks: {
    cell: {
      description: 'Cell Phone',
      amount: 960,
    },
    commute: {
      description: 'Commuter Stipend',
      amount: 3060,
    },
    enrich: {
      description: 'Enrichment Stipend',
      amount: 500,
    },
    food: {
      description: 'Food',
      amount: 5980,
    },
    gym: {
      description: 'Gym',
      amount: 600,
    },
  },
  health: {
    hmo: {
      coverEmp: {
        plan: 5802.36,
        vision: 147.96,
      },
      coverEmpSpouse: {
        plan: 12765.24,
        vision: 253.68,
      },
      coverEmpChild: {
        plan: 11604.72,
        vision: 258.96,
      },
      coverEmpSpouseChild: {
        plan: 17407.08,
        vision: 417.48,
      },
    },
    ppo: {
      coverEmp: {
        plan: 9644.88,
        vision: 147.96,
      },
      coverEmpSpouse: {
        plan: 21216.96,
        vision: 253.68,
      },
      coverEmpChild: {
        plan: 17359.68,
        vision: 258.96,
      },
      coverEmpSpouseChild: {
        plan: 29897.88,
        vision: 417.48,
      },
    },
    ppoFiveHundred: {
      coverEmp: {
        plan: 7493.52,
        vision: 147.96,
      },
      coverEmpSpouse: {
        plan: 16485.24,
        vision: 253.68,
      },
      coverEmpChild: {
        plan: 13488.24,
        vision: 258.96,
      },
      coverEmpSpouseChild: {
        plan: 23230.2,
        vision: 417.48,
      },
    },
  },
  dental: {
    base: {
      coverEmp: {
        dentalplan: 586.32,
      },
      coverEmpSpouse: {
        dentalplan: 1170.84,
      },
      coverEmpChild: {
        dentalplan: 1392.6,
      },
      coverEmpSpouseChild: {
        dentalplan: 1977.24,
      },
    },
    premium: {
      coverEmp: {
        dentalplan: 777.6,
      },
      coverEmpSpouse: {
        dentalplan: 1549.2,
      },
      coverEmpChild: {
        dentalplan: 1841.64,
      },
      coverEmpSpouseChild: {
        dentalplan: 2613.72,
      },
    },
  },
};
